import { defineSlotRecipe } from '@chakra-ui/react';

const Checkbox = defineSlotRecipe({
  slots: ['root', 'control', 'label'],
  base: {
    label: {
      color: 'podcastShade600',
      _invalid: {
        color: 'podcastRed600',
      },
    },
    control: {
      bg: 'white',
      borderWidth: '1px',
      borderRadius: '6px',
      boxShadow: 'inset 0px -2px 4px rgba(61, 58, 117, 0.09)',
      my: '4px',
    },
  },
  variants: {
    visual: {
      solid: {
        control: {
          borderColor: 'podcastShade300',
          '&:is([data-state=checked])': {
            background: 'podcastPurple',
            borderColor: 'podcastPurple800',
          },
        },
      },
      round: {
        control: {
          borderColor: 'podcastShade300',
          borderRadius: 'full',
          boxShadow: 'none',
          w: '22px',
          h: '22px',
          '&:is([data-state=checked])': {
            background: 'podcastPurple',
            borderColor: 'podcastPurple800',
          },
        },
      },
      merge: {
        control: {
          borderColor: 'podcastShade300',
          borderRadius: '50%',
          border: 'none',
          background: 'none',
          '&:is([data-state=checked])': {
            background: 'podcastPurple',
            borderColor: 'podcastPurple800',
          },
        },
      },
    },
    sizes: {
      md: {
        control: { w: '20px', h: '20px' },
      },
      lg: {
        control: { w: '33px', h: '33px' },
      },
    },
  },

  defaultVariants: {
    visual: 'solid',
    sizes: 'md',
  },
});

export default Checkbox;
